import React from "react";

// Shown on the create form for a listing started from a saved search: says
// where the fields came from and lists what the API guessed, so the agent
// checks those before publishing.
const PendingImportBanner = ({ notes }) => (
  <div className="pending-import-banner" role="status">
    <p className="pending-import-banner__title">
      Filled in from your saved search. Check these before you publish:
    </p>
    {notes.length > 0 && (
      <ul>
        {notes.map((note) => (
          <li key={note}>{note}</li>
        ))}
      </ul>
    )}
  </div>
);

export default PendingImportBanner;
